export default __webpack_public_path__ + "assets/images/da7e5801466f2a605e63d4d814556d08.jpeg";